import { connect } from 'react-redux';
import ScanCardInsurancePickerView from './ScanCardInsurancePickerV2View';
import { clickPlan, fetchScanCard, clickContinue } from '../ScanCardActions';
import { getScanCardState } from '../../../data/scan-card/scanCardSelector';
import { SCAN_CARD_STATUS_SUCCESS } from '../../../data/scan-card/scanCardReducer';

export function mapStateToProps(state) {
    const cardState = getScanCardState(state);

    const {
        repickCarrier,
        selectedInsurance,
        imageFront,
        status,
        editingCarrier,
        editingPlan,
    } = cardState;

    return {
        selectedInsurance,
        repickCarrier,
        imageFront,
        status,
        showResults: status === SCAN_CARD_STATUS_SUCCESS && !editingCarrier && !editingPlan,
        showCarriers: editingCarrier,
        showPlans: editingPlan,
    };
}

export const mapDispatchToProps = {
    clickPlan,
    fetchScanCard,
    clickContinue,
};

export const ScanCardInsurancePickerConnector = connect(
    mapStateToProps,
    mapDispatchToProps
)(ScanCardInsurancePickerView);
